import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { CONFIG_TOKEN } from '@core/tokens';

import {
  AvailableUserRolesResponse,
  CreateUserRequest,
  ImpersonationTokenResponse,
  UpdateUserRolesRequest,
  UserListResponse,
} from './users.models';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  readonly #ROOT_URL = inject(CONFIG_TOKEN).backendRootUrl;
  readonly #httpClient = inject(HttpClient);

  public getUsers$(tenantId?: string): Observable<UserListResponse> {
    return this.#httpClient.get<UserListResponse>(`${this.#ROOT_URL}/api/v1/users`, {
      params: tenantId ? { tenantId } : undefined,
    });
  }

  public getAvailableRoles$(tenantId?: string): Observable<AvailableUserRolesResponse> {
    return this.#httpClient.get<AvailableUserRolesResponse>(`${this.#ROOT_URL}/api/v1/users/available-roles`, {
      params: tenantId ? { tenantId } : undefined,
    });
  }

  public updateUserRoles$(userId: string, request: UpdateUserRolesRequest, tenantId?: string): Observable<void> {
    return this.#httpClient.put<void>(`${this.#ROOT_URL}/api/v1/users/${userId}/roles`, request, {
      params: tenantId ? { tenantId } : undefined,
    });
  }

  public createUser$(request: CreateUserRequest, tenantId?: string): Observable<void> {
    return this.#httpClient.post<void>(`${this.#ROOT_URL}/api/v1/users`, request, {
      params: tenantId ? { tenantId } : undefined,
    });
  }

  public resetUserMfa$(userId: string, tenantId?: string): Observable<void> {
    return this.#httpClient.post<void>(`${this.#ROOT_URL}/api/v1/users/${userId}/mfa/reset`, null, {
      params: tenantId ? { tenantId } : undefined,
    });
  }

  public resendUserInvite$(userId: string, tenantId?: string): Observable<void> {
    return this.#httpClient.post<void>(`${this.#ROOT_URL}/api/v1/users/${userId}/invite/resend`, null, {
      params: tenantId ? { tenantId } : undefined,
    });
  }

  public impersonate$(userId: string): Observable<ImpersonationTokenResponse> {
    return this.#httpClient.post<ImpersonationTokenResponse>(`${this.#ROOT_URL}/api/v1/users/${userId}/impersonation`, null);
  }
}
